import { render, staticRenderFns } from "./StatTitle.vue?vue&type=template&id=021642f0&"
import script from "./StatTitle.vue?vue&type=script&lang=js&"
export * from "./StatTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports